import { render } from "./mapaComponent.vue?vue&type=template&id=6478ec21"
import script from "./mapaComponent.vue?vue&type=script&lang=js"
export * from "./mapaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__